export default __webpack_public_path__ + "static/media/Icon-menu_changelog.2cd0adfe.svg";